import { render, staticRenderFns } from "./CartStatus.vue?vue&type=template&id=320a68e6&scoped=true&"
import script from "./CartStatus.vue?vue&type=script&lang=js&"
export * from "./CartStatus.vue?vue&type=script&lang=js&"
import style0 from "./CartStatus.vue?vue&type=style&index=0&id=320a68e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a68e6",
  null
  
)

export default component.exports